<template>
    <h1>{{ staticConfig.title }}</h1>
</template>
<script>
export default {
    
}
</script>